import type { FaireProductEntity } from "../../entity_types/product";

export const p_n33msrc88v: FaireProductEntity = {
  token: "p_n33msrc88v",
  type: "product",
  name: "Tire-Shaped Dog bowl",
  brandToken: "b_6qajwqdzz3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7343cbdb1f570f832d6cd4ad142d201eee45e6ad89acddbe4694b6c7134870cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f90e8962547c13546747fc2918a1baa9ccac934d4b25a435ccd5c08915f29f8e.jpeg",
    "https://cdn.faire.com/fastly/8784703d88831b96c15fd809d27604ed9d3cdcad043a1ee00f9641ffc52d5b93.jpeg",
    "https://cdn.faire.com/fastly/7067dda10973994f979237aed0886a3faec2f181440bc7a6e9f26f3a02055fa7.jpeg",
    "https://cdn.faire.com/fastly/8ef825c3376e0ea7f00ca69a1cf57cfd8e89cd57bf1b0ec54e0053990d1b33a4.jpeg",
    "https://cdn.faire.com/fastly/f5d1460219b02fa98f08413d31e0a2d569d37cd3f9922165034133c21d1123ec.jpeg",
  ],
  priceDollars: 17.32,
  description:
    "\"Drive your pet's dining experience to the next level with our unique Tire Shaped Dog Bowl. Packed with features that are both functional and fun, this pet bowl serves up a hearty helping of style and convenience. Designed to resemble an authentic tire, this pet food bowl takes the 'fast' in 'fast food' to a new and exciting reality. No more racing around at mealtimes; your furry friend can park themselves at their very own pit stop and enjoy their grub in a cool, car-themed setting. The removable stainless steel bowl nestled in the middle of the tire makes refueling easy and quick. Fill it up with your pet's favorite food or water, and you're ready for the 'lap' of luxury.",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:07.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
